var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJtagSelectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.01038 6.00793C7.16467 6.00793 6.47656 6.69604 6.47656 7.54175C6.47656 8.38745 7.16467 9.07544 8.01038 9.07544C8.85608 9.07544 9.54407 8.38745 9.54407 7.54175C9.54407 6.69604 8.85608 6.00793 8.01038 6.00793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.35999 12.5134C8.92969 12.6304 8.47717 12.6929 8.01025 12.6929C5.17004 12.6929 2.85938 10.3818 2.85938 7.5415C2.85938 4.70129 5.17004 2.39063 8.01025 2.39063C10.8506 2.39063 13.1616 4.70129 13.1616 7.5415C13.1616 8.86536 12.6597 10.0737 11.8359 10.9872L13.8225 11.5194C14.6216 10.3571 15.0522 8.98267 15.0522 7.54175C15.0522 5.66077 14.3197 3.89246 12.9897 2.5625C11.6597 1.23242 9.89136 0.5 8.0105 0.5C6.12952 0.5 4.36121 1.23242 3.03125 2.5625C1.70117 3.89246 0.96875 5.66077 0.96875 7.54175C0.96875 9.42261 1.70117 11.1909 3.03125 12.521C4.36121 13.851 6.12952 14.5835 8.0105 14.5835C8.64038 14.5835 9.25745 14.5007 9.84985 14.3413L9.35999 12.5134Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2241 7.5415C12.2241 5.21838 10.3337 3.32812 8.01025 3.32812C5.68713 3.32812 3.79688 5.21838 3.79688 7.5415C3.79688 9.86499 5.68713 11.7554 8.01025 11.7554C8.39307 11.7554 8.7644 11.7041 9.11719 11.6078L8.72778 10.1544L10.7891 10.7065C11.6685 9.93372 12.2241 8.80127 12.2241 7.5415ZM8.0105 10.0129C6.64783 10.0129 5.53918 8.9043 5.53918 7.54175C5.53918 6.17908 6.64783 5.07043 8.0105 5.07043C9.37317 5.07043 10.4817 6.17908 10.4817 7.54175C10.4817 8.9043 9.37305 10.0129 8.0105 10.0129Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1328 14.9159L13.7169 16.5L15.0735 15.1434L13.4894 13.5593L14.4034 12.6456L10.0537 11.4803L11.2191 15.8297L12.1328 14.9159Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJtagSelectIcon);
export default __webpack_public_path__ + "static/media/jtagSelectIcon.b4caed6284900e7beae0f8e79c518ca1.svg";
export { ForwardRef as ReactComponent };